export default __webpack_public_path__ + "static/media/backup-wallet-img.69a81c15.webp";